app.bind('default', function (context) {
    const $news = $('[js-news]', context);
    const $newsItem = $('[js-news-item]', context);
    const $newsActions = $('[js-news-actions]', context);
    const $newsMore = $('[js-news-more]', context);
    $newsMore.on('click', function () {
        $newsItem.removeClass('is-hidden');
        $newsActions.hide()
    })
});
